<script setup>
import {defineProps} from "vue";
import {useRouter} from "vue-router";
import useHelper from "@/composables/useHelper";

const {getButtonClass, getContentButtonLabel} = useHelper();
const router = useRouter();

const props = defineProps({
    content: Object,
    index: Number,
    mobile: Boolean
});

const classes = props.mobile ? 'mt-4 rounded w-full py-3 text-xs text-white lg:hidden' : 'mt-3 w-48 rounded-full py-3 text-xs text-white hidden lg:block';

</script>

<template>
    <button @click="() => router.push({ name: 'content', params: { id: props.content.id, mission: props.content.mission_id } })"
            :class="getButtonClass(classes, props.content, index)"
            :disabled="props.disabled">
        {{ getContentButtonLabel(props.content.content_type_vertical) }}
    </button>
</template>

